import { Action } from '@features/state/action.interface';
import { transform } from 'lib/transform';
import { pushOrReplace, dig } from '@imcc/utilities';
import { ExternalUserRegistrationActionPayload as ActionPayload } from './external-user-registration-action-payload.interface';
import { ExternalUserRegistrationActions as actions } from './external-user-registration-actions.enum';
import { ExternalUserRegistrationState as State } from './external-user-registration-state.interface';

export function externalUserRegistrationReducer(
  state: State,
  action: Action<ActionPayload>,
): State {
  const newState = { ...state } || { list: [], isUpdating: false };
  const { list, item } = action.payload || new ActionPayload();

  switch (action.type) {
    case actions.UPDATE_LIST_REQUEST:
      return transform(State, { ...newState, isUpdating: true });
    case actions.UPDATE_LIST_SUCCESS:
      return transform(State, { ...newState, isUpdating: false, list });
    case actions.UPDATE_LIST_ERROR:
      return transform(State, { ...newState, isUpdating: false });

    case actions.CREATE_REQUEST:
      return transform(State, { ...newState, isUpdating: true });
    case actions.CREATE_SUCCESS:
      return transform(State, {
        ...newState,
        isUpdating: false,
        list: pushOrReplace(
          newState.list,
          item,
          (currentItem) => dig(currentItem, 'id') === dig(item, 'id'),
        ),
      });
    case actions.CREATE_ERROR:
      return transform(State, { ...newState, isUpdating: false });
    default:
      return new State();
  }
}
